import { useTranslation } from "react-i18next";
import "./NotFound.scss";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="not-found">
      <div className="not-found-content">
        <h1>{t("not_found.page_name")}</h1>
        <p>{t("not_found.description")}</p>
      </div>
    </div>
  );
}
